import { Button } from "@components/common/button/button";
import { Option } from "@components/common/option/option";
import { Skeleton } from "@components/common/skeleton/skeleton";
import { FunctionComponent } from "react";

interface SidebarSkeletonProps {
    expanded: boolean;
}

export const SidebarSkeleton: FunctionComponent<SidebarSkeletonProps> = ({ expanded }) => {
    return (
        <>
            <div className="flex items-center justify-center gap-8 lg:hidden">
                <Skeleton className="h-7 w-7 bg-gray-500" rounded="full" />
                <Skeleton className="h-7 w-7 bg-gray-500" rounded="full" />
                <Skeleton className="h-7 w-7 bg-gray-500" rounded="full" />
                <Skeleton className="h-7 w-7 bg-gray-500" rounded="full" />
            </div>
            <div className="mt-8 hidden pb-8 lg:block">
                <div>
                    {expanded && (
                        <div className="px-2 pb-2 text-3xs text-gray-600">
                            <Skeleton width={70} height={20} className="bg-gray-60" rounded="md" />
                        </div>
                    )}
                    {expanded ? (
                        <>
                            <Option
                                leftAdornments={
                                    <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded transition-all duration-300 ease-out-cubic">
                                        <Skeleton className="h-5 w-5 bg-gray-500" rounded="full" />
                                    </div>
                                }
                                label={<Skeleton width={100} height={22} className="bg-gray-60" rounded="md" />}
                                rounded="lg"
                            />
                            <Option
                                leftAdornments={
                                    <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded transition-all duration-300 ease-out-cubic">
                                        <Skeleton className="h-5 w-5 bg-gray-500" rounded="full" />
                                    </div>
                                }
                                label={<Skeleton width={135} height={22} className="bg-gray-60" rounded="md" />}
                                rounded="lg"
                            />
                            <Option
                                leftAdornments={
                                    <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded transition-all duration-300 ease-out-cubic">
                                        <Skeleton className="h-5 w-5 bg-gray-500" rounded="full" />
                                    </div>
                                }
                                label={<Skeleton width={80} height={22} className="bg-gray-60" rounded="md" />}
                                rounded="lg"
                            />
                        </>
                    ) : (
                        <>
                            <Button leftAdornments={<Skeleton rounded="md" className="size-5" />} color="white" rounded="md" />
                            <Button leftAdornments={<Skeleton rounded="md" className="size-5" />} color="white" rounded="md" />
                            <Button leftAdornments={<Skeleton rounded="md" className="size-5" />} color="white" rounded="md" />
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
